import { FunctionComponent } from "react";

import { useBlocksClinicalStoreActions } from "@bps/blocks";
import {
  CenteredBox,
  FontIcon,
  FontSizes,
  Heading,
  Link,
  Stack,
  Text,
  useTheme
} from "@bps/fluent-ui";
import { logout } from "@bps/msal";

import { usePermissionsChecker } from "../../core/auth/Permissions";
import { Permission } from "../../core/common-types/permission.enum";

export const AuthorizationErrorBox: FunctionComponent = () => {
  const theme = useTheme();

  const { resetSessionValues } = useBlocksClinicalStoreActions();

  const hasPermissions = usePermissionsChecker();
  const hasBpmWebAllowedPermission = hasPermissions(
    Permission.ProsBpmWebAllowed
  );

  const onLoginClick = async () => {
    hasBpmWebAllowedPermission && resetSessionValues();
    await logout();
  };
  return (
    <CenteredBox tokens={{ childrenGap: 10 }}>
      <Stack
        styles={{
          root: {
            width: "90px",
            height: "90px",
            backgroundColor: theme.palette.neutralTertiaryAlt,
            borderRadius: "62px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }
        }}
      >
        <FontIcon
          iconName="Lock"
          styles={{
            root: { color: theme.palette.white, fontSize: FontSizes.size32 }
          }}
        />
      </Stack>
      <Heading variant="heading">Access denied</Heading>
      <Text>You do not have permission to access Premier Online.</Text>
      <Text>
        Please check your user permissions or contact your Bp Premier
        administrator.
      </Text>
      <Text>
        Alternatively,{" "}
        <Link onClick={onLoginClick}> log in as a different user.</Link>
      </Text>
    </CenteredBox>
  );
};
